// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__39MUW","buttons":"SendReceipts_buttons__3TDhH","email":"SendReceipts_email__2bszn","bookApptTitle":"SendReceipts_bookApptTitle__1IweH"};